import { AppLayout, State, useLayout } from "core";
import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppNavigation } from "src/utils/Navigation/useAppNavigation";
import { useSignupURL } from "src/utils/useSignupURL";
// Component that redirects on plan selection or payment selection when no subscription is available

const SubscriptionRedirect = (props: { onRedirect: () => void }) => {
  const { redirectToSubscription } = useSubscriptionRedirect();
  useEffect(() => {
    redirectToSubscription();
    props.onRedirect();
  }, [props, redirectToSubscription]);

  return null;
};

export const useSubscriptionRedirect = () => {
  const { organization } = useSelector((state: State) => state.globalState);
  const { createSubURL } = useSignupURL();
  const { profile } = useSelector((state: State) => state.profilesState);
  const { navigate } = useAppNavigation();
  const layout = useLayout();

  const redirectToSubscription = useCallback(async () => {
    if (!profile || !profile.isMaster) {
      return;
    }
    if (layout === AppLayout.TV) {
      navigate("/checkout/tv");
    } else if (organization && organization.subscriptionUrl) {
      window.open(organization.subscriptionUrl, "_blank");
      navigate("/");
    } else {
      window.open(await createSubURL(), "_blank");
    }
  }, [createSubURL, navigate, layout, organization, profile]);
  return {
    redirectToSubscription,
  };
};
export default SubscriptionRedirect;
